import React from "react";
import { BrowserRouter, Route, Switch,Redirect  } from "react-router-dom";

import { isAuthenticated } from "../services/auth";
import Login from '../pages/Login';
import User from '../pages/CadUser';
import HomeUsers from '../pages/HomeUsers';
import ContraPage from "../pages/ContraPage";
import HomeAdmin from '../pages/HomeAdmin'
import AddContra from "../pages/AddContraCheque";
import ContraChequesUser from "./ContraChequesUser"

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={Login} />
      
      <PrivateRoute path="/homeUser" component={HomeUsers} />
      <PrivateRoute path="/homeAdm" component={HomeAdmin} />
      <PrivateRoute path="/user" component={User} />
      <PrivateRoute path="/ContraCheques" component={ContraPage} />
      <PrivateRoute path="/AddContraCheques" component={AddContra} />
      <PrivateRoute path="/ContraChequesUser" component={ContraChequesUser} />

      <Route path="*" component={() => <h1>Page not found</h1>} />
    </Switch>
  </BrowserRouter>
);

export default Routes;